export enum EmailValidationResponseStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  SUGGESTION = 'SUGGESTION',
  NOT_VALIDATED = 'NOT_VALIDATED',
  INVALID_CONDITIONALLY = 'INVALID_CONDITIONALLY',
  REQUIRED = 'REQUIRED',
}

export enum GuestLoginResponseCode {
  VALIDATION = 'VALIDATION',
}
